import React from 'react';
import Nbsp from '../../../../shared/components/Nbsp';
import PaginationControls from '../../../../shared/components/PaginationControls';
import SearchControls from '../../../../shared/components/SearchControls';
import SkeletonWrapper from '../../../../shared/components/skeleton/SkeletonWrapper';
import OrganizationInfoCard from './OrganizationInfoCard';

const PAGE_SIZE = 20;

/**
 * @typedef {object} OrganizationListSearchState
 * @property {number} [currentPage]
 * @property {string} [searchText]
 * @property {string} [searchChar]
 * @property {Array<number>} [searchOHT]
 * @property {(searchState: { searchText?: string, searchChar?: string, searchOHT?: Array<number>, currentPage?: number }) => void} [setSearchState]
 */

/**
 * @typedef {object} OrganizationListProps
 * @property {(organizationId: number) => void} onSelectOrganization
 * @property {boolean} [shouldShowSearchControls]
 * @property {Array<*>} [organizations]
 * @property {number} [totalCount]
 * @property {boolean} [loading]
 * @property {string} searchTextPlaceholder
 * @property {OrganizationListSearchState} searchState
 */

/**
 * @param {OrganizationListProps} props
 */
export const OrganizationList = props => {
  const {
    onSelectOrganization,
    searchTextPlaceholder,
    organizations = [],
    totalCount = 0,
    shouldShowSearchControls = false,
    loading = false,
    searchState
  } = props;

  const { currentPage, searchText, searchChar, searchOHT, setSearchState } = searchState;

  const totalPages = Math.ceil(totalCount / PAGE_SIZE);

  return (
    <div className='item-search'>
      {shouldShowSearchControls && (
        <SearchControls
          setSearchState={setSearchState}
          selectedSearchText={searchText}
          selectedSearchChar={searchChar}
          selectedSearchOHTs={searchOHT}
          searchTextPlaceholder={searchTextPlaceholder}
        />
      )}
      <div className='item-search__results-count' data-testid='results-count'>
        <p>
          Results:
          <Nbsp />
          <SkeletonWrapper show={loading} renderComponent={() => totalCount} />
        </p>
        <PaginationControls
          currentPage={currentPage}
          totalPages={totalPages}
          onClick={val => setSearchState({ currentPage: val })}
        />
      </div>
      <div className='search-result'>
        <SkeletonWrapper
          show={loading}
          renderComponent={() => {
            return (
              <>
                {organizations.length === 0 && <p>Search above to see results</p>}
                {organizations.length > 0 && (
                  <>
                    {organizations.map(org => (
                      <OrganizationInfoCard key={org.Id} onClick={onSelectOrganization} org={org} />
                    ))}
                    <div className='item-search__pagination-bottom'>
                      <PaginationControls
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onClick={val => setSearchState({ currentPage: val })}
                      />
                    </div>
                  </>
                )}
              </>
            );
          }}
        />
      </div>
    </div>
  );
};
